export default __webpack_public_path__ + "static/media/bankopen.3d20616d.jpg";